import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MasterData from '../../data/MasterData'

const IzuminoRouteMap = ({ locale, themeName }) => {
  const getStationsByLineId = (lineId) => {
    return MasterData.trainPositionTab(lineId).stations.map(station => MasterData.station(station.id))
  }

  const stations = getStationsByLineId(2)

    return (
      <ul className="d-Routemap-station">
        <li className="d-Routemap-stationItem d-Routemap-stationItem--firstIzumino">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[0][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromIzuminoToMain is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromIzuminoToMain is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromIzuminoToMain is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromIzuminoToMain is_local is_station"></div>
          </div>
          <Link to={`/lines/main/route_map`} className={`d-Routemap-lineSwitch d-Routemap-lineSwitch-${themeName} d-Routemap-lineSwitch--fromIzuminoToMain`}>
            <p className="d-Routemap-lineSwitchText">{MasterData.line(1)[`name_${locale}`]}</p>
          </Link>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[1][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[2][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[3][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[4][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[5][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[6][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_terminal_station"></div>
          </div>
        </li>
      </ul>
    )
}

IzuminoRouteMap.propTypes = {
  locale: PropTypes.string.isRequired,
  themeName: PropTypes.string.isRequired,
}

export default IzuminoRouteMap
